import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store';
import EkDetails from '@/components/EkDetails';
import MainPage from '@/components/MainPage';
import KanjiPrint from '@/components/KanjiPrint';
import cmsRouter from '@/cms/router';
import Kana from '@/components/Kana';
import KanaPrint from '@/components/KanaPrint';
import Cardgame from '@/components/cardgame/main'
import CardgameAdmin from '@/components/cardgame/admin/admin'
Vue.use(Router);
const router = new Router ({
  mode:'history',
  base: process.env.BASE_URL,
  routes: [
    {
    path: '/',
    name: "mainPage",
    component: MainPage,
    meta: {
      title: 'a4edu - main page',
    }
  },
  {
    path: '/kanji/:kanji',
    name: "Scheda Kanji",
    component: EkDetails
  },
  {
    path: '/kanji/:kanji/admin',
    name: "Scheda Kanji",
    component: EkDetails,
    meta:{isFrontendAdmin:1}
  },
  {
    path: '/print/:kanji',
    name: 'Stampa scheda',
    component: KanjiPrint
  },
  {
    path: '/kana/:kana',
    name: 'Kana',
    component: Kana
  },
  {
    path: '/kanaprint/:kana',
    name: 'Stampa scheda',
    component: KanaPrint
  },
  {
    path :'/cardgame',
    name: 'Card game',
    component:Cardgame
  },
  {
    path :'/cardgame/admin',
    name: 'Cardgame Admin',
    component:CardgameAdmin
  },
 ...cmsRouter
  ]
})
router.beforeEach((to,from,next)=>{
  console.log(to);
  if (typeof to.meta.requiresLogin != undefined && to.meta.cmsLogin == true) {
    if (store.getters.isLoggedIn == false) {
      next("/cms/login");
    }
  }
  if (!to.matched.length) {
    next(new Error(`Location "${to.fullPath}" does not exist`)) 
  } else {
    next();

  }
});

export default router;